/**
 * @file
 * Behaviors for level classes.
 */

!(Drupal => {
  'use strict';

  Drupal.behaviors.levelClasses = {
    attach: function() {
      // Variables
      const body = document.querySelector('body');

      // eslint-disable-next-line valid-jsdoc

      /**
       * @function
       * Adds classes to breadcrumb level links.
       */
      function sortBreadcrumb() {
        const links = document.querySelectorAll('.breadcrumb__link');

        links.forEach(element => {
          var text = element.innerHTML.replace('å', 'a');
          text = text.charAt(0).toLowerCase() + text.slice(1);

          if (
            (text === 'barnehage') |
            (text === 'barnetrinn') |
            (text === 'ungdomstrinn') |
            (text === 'videregaende') |
            (text === 'eiere og ledelse')
          ) {
            element.parentElement.classList.add('level');
            element.parentElement.classList.add(text);
          }
        });
      }

      /**
       * @function
       * Adds classes based on cookie.
       */
      function updateClasses() {
        const cookie = localStorage.getItem('levelClass');
        if (cookie === '1' && body.classList.contains('term-name--barnehage')) {
          body.classList.add('navigated-from--barnehage');
        }
        else if (
          cookie === '2' &&
          body.classList.contains('term-name--barnetrinn')
        ) {
          body.classList.add('navigated-from--barnetrinn');
        }
        else if (
          cookie === '3' &&
          body.classList.contains('term-name--ungdomstrinn')
        ) {
          body.classList.add('navigated-from--ungdomstrinn');
        }
        else if (
          cookie === '4' &&
          body.classList.contains('term-name--videregående')
        ) {
          body.classList.add('navigated-from--videregående');
        }
        else if (
          cookie === '5' &&
          body.classList.contains('term-name--eiere-og-ledelse')
        ) {
          body.classList.add('navigated-from--eiere-og-ledelse');
        }
        else {
          body.classList.add('no-match');
        }
      }

      // eslint-disable-next-line valid-jsdoc
      /**
       * @function
       * Updates cookie value.
       */
      function updateCookie() {
        // Get taxonomy from level and theme pages
        if (
          body.classList.contains('path-taxonomy') ||
          body.classList.contains('page-node-type-theme')
        ) {
          // Set cookie for each class
          if (body.classList.contains('term-name--barnehage')) {
            localStorage.setItem('levelClass', '1');
          }
          else if (body.classList.contains('term-name--barnetrinn')) {
            localStorage.setItem('levelClass', '2');
          }
          else if (body.classList.contains('term-name--ungdomstrinn')) {
            localStorage.setItem('levelClass', '3');
          }
          else if (body.classList.contains('term-name--videregående')) {
            localStorage.setItem('levelClass', '4');
          }
          else if (body.classList.contains('term-name--eiere-og-ledelse')) {
            localStorage.setItem('levelClass', '5');
          }
        }
      }

      //Set cookies for remembering last visited level
      if (window['localStorage']) {
        sortBreadcrumb();
        updateCookie();
        updateClasses();
      }
    }
  };
})(Drupal);
